// @flow
import {Divider, makeStyles, Typography} from '@material-ui/core';
import React from 'react';

import {colors} from '../../../assets/styles/colors';
import CustomButton from '../../../elements/CustomButton/CustomButton';

import {connect} from 'react-redux';
import type {RootState} from '../../index';
import {ProgressBar} from '../../../elements/ProgressBar/ProgressBar';

export default connect(
  (state: RootState) => ({
    ordersCount: state.orders.ordersCount,
  }),
  null
)(OrderCounter);

type Props = {
  ordersCount?: number,
};

const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      position: 'fixed',
      bottom: 64,
      left: 0,
      width: '100%',
      background: 'white',
      // zIndex: 1301,
    },
  },
  content: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  divider: {
    margin: theme.spacing(0, 1, 0, 1),
    [theme.breakpoints.down('sm')]: {
      margin: 'unset',
    },
  },
  title: {
    fontSize: '0.875rem',
    fontWeight: 700,
    color: colors.grey600,
  },
  bottomSection: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'end',
    },
  },
  leftSection: {
    width: '100%',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  subtitle: {
    margin: theme.spacing(1, 0),
    fontSize: '0.875rem',
    color: colors.grey600,
  },
  button: {
    marginTop: theme.spacing(3),
    width: '100%',
    height: 36,
    [theme.breakpoints.down('sm')]: {
      width: 'unset',
      marginTop: 'unset',
      marginLeft: theme.spacing(2),
    },
  },
}));

function OrderCounter(props: Props) {
  const {ordersCount} = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Divider className={classes.divider} />
      <div className={classes.content}>
        <Typography className={classes.title}>Plan gratuito</Typography>
        <div className={classes.bottomSection}>
          <div className={classes.leftSection}>
            <div className={classes.row}>
              <Typography className={classes.subtitle}>Ventas</Typography>
              <Typography className={classes.subtitle}>
                {ordersCount}/21
              </Typography>
            </div>
            {typeof ordersCount === 'number' && (
              <ProgressBar value={(ordersCount * 100) / 21} />
            )}
          </div>
          <CustomButton
            variant="outlined"
            className={classes.button}
            to="/tiers-list"
          >
            Mejorar plan
          </CustomButton>
        </div>
      </div>
    </div>
  );
}
